import { Reveal } from "./Reveal";
import { SERVICE_OPTIONS } from "../data/site";
import { useQuoteForm } from "../hooks/useQuoteForm";
import { QuoteSidebar } from "./quote/QuoteSidebar";
import { PhotoUpload } from "./quote/PhotoUpload";
import { Field, PillGroup } from "./quote/FormControls";

export default function QuoteForm() {
  const { form, photos, sending, set, choose, addPhotos, removePhoto, submit } = useQuoteForm();

  return (
    <section id="quote" className="bg-[#F4F4F6] text-zinc-900 py-20 lg:py-28 scroll-mt-16">
      <div className="container-x grid lg:grid-cols-5 gap-12 lg:gap-16">
        <QuoteSidebar />

        <Reveal delay={0.12} className="lg:col-span-3">
          <form data-testid="quote-form" onSubmit={submit} className="bg-white rounded-3xl border border-black/10 shadow-2xl p-6 sm:p-10">
            <div className="grid sm:grid-cols-2 gap-5">
              <Field label="Name *">
                <input data-testid="quote-form-name-input" required value={form.name} onChange={set("name")} className="input-light" placeholder="Your full name" />
              </Field>
              <Field label="Phone *">
                <input data-testid="quote-form-phone-input" required type="tel" value={form.phone} onChange={set("phone")} className="input-light" placeholder="04XX XXX XXX" />
              </Field>
              <Field label="Email *">
                <input data-testid="quote-form-email-input" required type="email" value={form.email} onChange={set("email")} className="input-light" placeholder="you@email.com" />
              </Field>
              <Field label="Service Required *">
                <select data-testid="quote-form-service-select" required value={form.service} onChange={set("service")} className="input-light">
                  <option value="" disabled>Select a service</option>
                  {SERVICE_OPTIONS.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
              </Field>
              <div data-testid="quote-form-category-radio" className="sm:col-span-2">
                <Field label="Residential or Commercial *">
                  <PillGroup options={["Residential", "Commercial"]} value={form.category} onChange={(v) => choose("category", v)} testidPrefix="quote-category" />
                </Field>
              </div>
              <Field label="Location / Suburb *" className="sm:col-span-2">
                <input data-testid="quote-form-suburb-input" required value={form.suburb} onChange={set("suburb")} className="input-light" placeholder="e.g. Brunswick, VIC" />
              </Field>
              <Field label="Project Details" className="sm:col-span-2">
                <textarea data-testid="quote-form-details-textarea" rows={4} value={form.details} onChange={set("details")} className="input-light resize-none" placeholder="Tell us about your vehicle, shopfront, office or home project — sizes, colours, deadlines, anything helps." />
              </Field>
              <Field label="Upload Photos (up to 6)" className="sm:col-span-2">
                <PhotoUpload photos={photos} onAdd={addPhotos} onRemove={removePhoto} />
              </Field>
              <div data-testid="quote-form-contact-method" className="sm:col-span-2">
                <Field label="Preferred Contact Method">
                  <PillGroup options={["Phone Call", "SMS", "Email"]} value={form.contact_method} onChange={(v) => choose("contact_method", v)} testidPrefix="quote-contact" />
                </Field>
              </div>
            </div>

            <button data-testid="quote-form-submit-button" type="submit" disabled={sending} className="btn-primary w-full mt-8 !py-4 text-sm disabled:opacity-60 disabled:hover:scale-100">
              {sending ? "SENDING..." : "REQUEST FREE QUOTE"}
            </button>
            <p className="mt-4 text-center text-xs text-zinc-500">
              Your details go straight to our Melbourne studio — never shared, never spammed.
            </p>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
